const is_twin = (s: string) => {
  return s.length === 2 && s[0] === s[1];
};

export { is_twin };
